import { Stack } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { useEffect } from 'react';
import { setFormSuccess } from 'state/reducers/contact.reducers';
import CallToAction from './CallToAction';
import Articles from 'components/Articles/Articles';
import { selectTranslations } from 'state/reducers/translation.reducers';
import InfoStrip from 'theme/elements/InfoStrip';

export default function PreBalanceAddition() {
  const dispatch = useAppDispatch();
  const t = useAppSelector(selectTranslations);

  useEffect(() => {
    dispatch(setFormSuccess(false));
  }, []);

  return (
    <Stack spacing={2}>
      <InfoStrip
        text={t('page.dashboard.plan_selected.text')}
        imageKey="page.dashboard.plan_selected.icon"
      />
      <CallToAction />
      <Articles theme='green' />
    </Stack>
  );
}
